var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76.9 76.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3{fill:none;stroke-miterlimit:10;}.cls-2{stroke:#fff;stroke-width:0.9px;}.cls-3{stroke:#018b9d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Guide") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 38.45,
    cy: 38.45,
    r: 32.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 38.45,
    cy: 38.45,
    r: 38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 38.45,
    cy: 39.38,
    r: 19.06
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "41.82 42.75 47.21 29.95 34.41 35.34 29.7 47.46 41.82 42.75"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 34.41,
    y1: 35.34,
    x2: 41.82,
    y2: 42.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.75,20.52a3.41,3.41,0,0,0,.07-.67,3.37,3.37,0,0,0-6.74,0,3.41,3.41,0,0,0,.07.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 38.45,
    y1: 20.52,
    x2: 38.45,
    y2: 23.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 38.45,
    y1: 54.87,
    x2: 38.45,
    y2: 58.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 57.31,
    y1: 39.38,
    x2: 53.95,
    y2: 39.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.96,
    y1: 39.38,
    x2: 19.59,
    y2: 39.38
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuide);
export default __webpack_public_path__ + "static/media/Guide.f95d3b509898a3c55d232bf849858459.svg";
export { ForwardRef as ReactComponent };